<template>
  <div>
    <PpvToast/>
    <PpvConfirm/>
    <super-multi-section-list
      :multi-section-title="multiSectionTitle"
      :multi-section-list="multiSectionList">
    </super-multi-section-list>
  </div>
</template>
<script>
import _ from 'lodash'
import { parseUrl } from 'query-string'
import { scrollTop } from '@/common/utils/common'
import SuperMultiSectionList from '@/components/container/SuperMultiSectionList'
import { apiRequest, applyQueryString } from '@/common/utils/request.common'
import { HTTP_METHOD_GET } from '@/common/utils/request.const'
import PpvConfirm from '@/components/movie/PpvConfirm'
import PpvToast from '@/components/movie/PpvToast'

export default {
  name: 'SuperMultiSectionIndex',
  components: {
    SuperMultiSectionList,
    PpvConfirm,
    PpvToast
  },
  data () {
    return {
      multiSectionTitle: '',
      multiSectionList: []
    }
  },
  methods: {
    async setData () {
      const { url, query } = parseUrl(decodeURIComponent(_.get(this.$route, 'query.api', '')))
      apiRequest({
        url: applyQueryString(`https://${url}`, query),
        method: HTTP_METHOD_GET
      }).then(({ data }) => {
        this.multiSectionTitle = _.get(data, 'note', '멀티섹션')
        this.multiSectionList = _.get(data, 'multisectionlist', [])
      })
    }
  },
  created () {
    this.setData()
  },
  mounted () {
    scrollTop()
  }
}
</script>
